export interface Aggregator {
  id?: string;
}

export enum CashFlowCategory {
  ATM = 'ATM',
  CARD_PAYMENT = 'CARD_PAYMENT',
  DIFFERED_PAYMENT = 'DIFFERED_PAYMENT',
  FAMILY_ALLOWANCE = 'FAMILY_ALLOWANCE',
  GAMBLING = 'GAMBLING',
  GAMBLING_GAIN = 'GAMBLING_GAIN',
  HEALTH_ALLOWANCE = 'HEALTH_ALLOWANCE',
  LOAN = 'LOAN',
  LOC_DRAWDOWN = 'LOC_DRAWDOWN',
  OTHER_EXPENSE = 'OTHER_EXPENSE',
  OTHER_INCOME = 'OTHER_INCOME',
  PAYMENT_REJECTION = 'PAYMENT_REJECTION',
  PERSO_TAX = 'PERSO_TAX',
  PERSO_TAX_PAYBACK = 'PERSO_TAX_PAYBACK',
  TELECOM = 'TELECOM',
  POWER = 'POWER',
  PRO_TAX = 'PRO_TAX',
  PRO_TAX_PAYBACK = 'PRO_TAX_PAYBACK',
  REGULAR_EXPENSE = 'REGULAR_EXPENSE',
  REGULAR_INCOME = 'REGULAR_INCOME',
  RENT = 'RENT',
  RENTAL_INCOME = 'RENTAL_INCOME',
  RETIREMENT_PENSION = 'RETIREMENT_PENSION',
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
  UNEMPLOYMENT_ALLOWANCE = 'UNEMPLOYMENT_ALLOWANCE',
  WAGE = 'WAGE',
  BANK_SERVICE_FEES = 'BANK_SERVICE_FEES',
  BANK_INCIDENT_FEES = 'BANK_INCIDENT_FEES',
  BANK_INCIDENT_REFUND = 'BANK_INCIDENT_REFUND',
  OVERDRAFT_FEES = 'OVERDRAFT_FEES',
  INSURANCE = 'INSURANCE',
  INSURANCE_REFUND = 'INSURANCE_REFUND',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  CHECK = 'CHECK',
  CHECK_DEPOSIT = 'CHECK_DEPOSIT',
  CHECK_REJECTION = 'CHECK_REJECTION',
  ATM_DEPOSIT = 'ATM_DEPOSIT',
  CARD_REFUND = 'CARD_REFUND',
  MULTIMEDIA = 'MULTIMEDIA',
  TOBACCO_SHOP = 'TOBACCO_SHOP',
  ANTICIPATED_LOAN_REFUND = 'ANTICIPATED_LOAN_REFUND',
  STATE_SUBSIDY = 'STATE_SUBSIDY',
  CHECK_REJECTION_FEES = 'CHECK_REJECTION_FEES',
  PAYMENT_REJECTION_FEES = 'PAYMENT_REJECTION_FEES',
  INTERVENTION_FEES = 'INTERVENTION_FEES',
  EXPENSE_REPORT_REFUND = 'EXPENSE_REPORT_REFUND',
  LEASING = 'LEASING',
  BANK_BENEFIT = 'BANK_BENEFIT',
}

export enum CashFlowType {
  ATM_DEPOSIT = 'ATM_DEPOSIT',
  ATM = 'ATM',
  CHECK_DEPOSIT = 'CHECK_DEPOSIT',
  CHECK = 'CHECK',
  DEBIT = 'DEBIT',
  INCOMING_TRANSFER = 'INCOMING_TRANSFER',
  OUTGOING_TRANSFER = 'OUTGOING_TRANSFER',
  INCOMING_INTERNAL_TRANSFER = 'INCOMING_INTERNAL_TRANSFER',
  OUTGOING_INTERNAL_TRANSFER = 'OUTGOING_INTERNAL_TRANSFER',
  CARD_PAYMENT = 'CARD_PAYMENT',
  CREDIT = 'CREDIT',
}
